import type { KyInstance } from 'ky';

import { ensureError, omit } from '@enterprise/core';
import type { OperationResultWithData, PagedData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { GetTagsByCategoryNameQuery } from './types/get-tags-by-category-name-query.type';
import type { Tag } from './types/tag.type';

/**
 * Retrieves tags by a given category name using the provided Ky HTTP client instance.
 *
 * @param instance - The KyInstance used to make the HTTP request.
 * @param query - The query parameters for fetching tags, excluding 'filter' and 'sort'.
 * @returns A promise that resolves to an OperationResultWithData containing paged Tag data.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getTagsByCategoryName = async (instance: KyInstance, query: GetTagsByCategoryNameQuery) => {
  try {
    const searchParams = omit(query, 'filter', 'sort');

    return await instance
      .get<OperationResultWithData<PagedData<Tag>>>(Uri.tags.getByCategoryName, { searchParams })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
